// extracted by mini-css-extract-plugin
export default {"ChooseProject":"ChooseProjectPage_ChooseProject__LkvJf","BtnCreateProject":"ChooseProjectPage_BtnCreateProject__eUqNN"};